import React, { useState, useEffect } from 'react';
import { db } from '../../firebase/firestore';
import { collection, setDoc, doc, getDocs, query, orderBy, addDoc, deleteDoc, updateDoc } from "firebase/firestore";

// Типы контента для слайда (удален MASTERCLASS)
const CONTENT_TYPES = {
  VIDEO: 'video',
  AUDIO: 'audio',
  TRAINING: 'training',
  BUTTON: 'button',
  TEXT: 'text'
};

const BASE_URL = "https://artdownload2-production.up.railway.app";

export default function MiniPathAdmin() {
  const [miniPaths, setMiniPaths] = useState([]);
  const [selectedPathId, setSelectedPathId] = useState(null);
  const [currentPath, setCurrentPath] = useState(null);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  
  // Списки контента из БД (удален masterClasses)
  const [audioLessons, setAudioLessons] = useState([]);
  const [trainings, setTrainings] = useState([]);
  const [showContentSelector, setShowContentSelector] = useState({ slideIndex: null, contentType: null });

  // Загрузка всех мини-путей и контента
  useEffect(() => {
    loadMiniPaths();
    loadContentLists();
  }, []);

  const loadContentLists = async () => {
    try {
      // Загрузка аудио-уроков
      const audioRef = collection(db, 'audioLessons');
      const audioSnapshot = await getDocs(audioRef);
      setAudioLessons(audioSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));

      // Загрузка тренингов
      const trainingsRef = collection(db, 'trainings');
      const trainingsSnapshot = await getDocs(trainingsRef);
      setTrainings(trainingsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));

      // Загрузка мастер-классов больше не нужна
    } catch (error) {
      console.error('Error loading content lists:', error);
    }
  };

  const loadMiniPaths = async () => {
    setLoading(true);
    try {
      const pathsRef = collection(db, 'miniPaths');
      const q = query(pathsRef, orderBy('order', 'asc'));
      const snapshot = await getDocs(q);
      const paths = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setMiniPaths(paths);
    } catch (error) {
      console.error('Error loading mini paths:', error);
    }
    setLoading(false);
  };

  // Функция загрузки изображения
  const uploadImage = async (file) => {
    // Валидация
    if (!file) return null;
    
    // Проверка типа файла
    if (!file.type.startsWith('image/')) {
      alert('Пожалуйста, выберите изображение');
      return null;
    }
    
    // Проверка размера (до 10MB)
    if (file.size > 10 * 1024 * 1024) {
      alert('Размер файла не должен превышать 10MB');
      return null;
    }

    setUploading(true);
    
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await fetch(`${BASE_URL}/upload?folder=lesson-images`, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Ошибка загрузки');
      }

      const data = await response.json();
      
      if (data.success) {
        const imageUrl = `${BASE_URL}${data.url}`;
        return imageUrl;
      } else {
        throw new Error('Ошибка при загрузке');
      }
    } catch (error) {
      console.error('Error uploading image:', error);
      alert('Ошибка при загрузке изображения');
      return null;
    } finally {
      setUploading(false);
    }
  };

  const createNewPath = async () => {
    const newPath = {
      title: 'Новый мини-путь',
      image: '',
      order: miniPaths.length,
      slides: [
        {
          number: 1,
          text: 'Текст 1 слайда',
          cardText: 'Карточка 1 слайда',
          contents: []
        }
      ],
      createdAt: new Date(),
      updatedAt: new Date()
    };

    try {
      const docRef = await addDoc(collection(db, 'miniPaths'), newPath);
      setSelectedPathId(docRef.id);
      setCurrentPath({ id: docRef.id, ...newPath });
      loadMiniPaths();
    } catch (error) {
      console.error('Error creating mini path:', error);
    }
  };

  const savePath = async () => {
    if (!currentPath) return;
    
    try {
      const pathRef = doc(db, 'miniPaths', currentPath.id);
      await updateDoc(pathRef, {
        ...currentPath,
        updatedAt: new Date()
      });
      loadMiniPaths();
      alert('Сохранено успешно!');
    } catch (error) {
      console.error('Error saving mini path:', error);
    }
  };

  const deletePath = async () => {
    if (!currentPath) return;
    
    if (window.confirm('Вы уверены, что хотите удалить этот мини-путь?')) {
      try {
        await deleteDoc(doc(db, 'miniPaths', currentPath.id));
        
        // Перенумеровываем order у оставшихся путей
        const updatedPaths = miniPaths
          .filter(p => p.id !== currentPath.id)
          .sort((a, b) => a.order - b.order)
          .map((path, index) => {
            updateDoc(doc(db, 'miniPaths', path.id), { order: index });
            return { ...path, order: index };
          });
        
        setCurrentPath(null);
        setSelectedPathId(null);
        loadMiniPaths();
      } catch (error) {
        console.error('Error deleting mini path:', error);
      }
    }
  };

  // Обработчик выбора изображения
  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const imageUrl = await uploadImage(file);
    if (imageUrl) {
      setCurrentPath({
        ...currentPath,
        image: imageUrl
      });
    }
  };

  const addSlide = () => {
    if (!currentPath) return;
    
    const newSlide = {
      number: currentPath.slides.length + 1,
      text: `Текст ${currentPath.slides.length + 1} слайда`,
      cardText: `Карточка ${currentPath.slides.length + 1} слайда`,
      contents: []
    };
    
    setCurrentPath({
      ...currentPath,
      slides: [...currentPath.slides, newSlide]
    });
  };

  const removeSlide = (index) => {
    if (!currentPath || currentPath.slides.length <= 1) return;
    
    const newSlides = currentPath.slides.filter((_, i) => i !== index);
    const renumberedSlides = newSlides.map((slide, idx) => ({
      ...slide,
      number: idx + 1
    }));
    
    setCurrentPath({
      ...currentPath,
      slides: renumberedSlides
    });
  };

  const updateSlideText = (index, field, value) => {
    const newSlides = [...currentPath.slides];
    newSlides[index] = {
      ...newSlides[index],
      [field]: value
    };
    setCurrentPath({
      ...currentPath,
      slides: newSlides
    });
  };

  // Добавление форматирования в текст
  const insertFormatting = (slideIndex, type) => {
    const textarea = document.getElementById(`cardText-${slideIndex}`);
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const selectedText = textarea.value.substring(start, end);
    const beforeText = textarea.value.substring(0, start);
    const afterText = textarea.value.substring(end);
    
    let formattedText = '';
    switch(type) {
      case 'bold':
        formattedText = `**${selectedText || 'жирный текст'}**`;
        break;
      case 'italic':
        formattedText = `*${selectedText || 'курсив'}*`;
        break;
      case 'code':
        formattedText = `\`${selectedText || 'код'}\``;
        break;
      case 'h1':
        formattedText = `# ${selectedText || 'Заголовок 1'}`;
        break;
      case 'h2':
        formattedText = `## ${selectedText || 'Заголовок 2'}`;
        break;
      case 'h3':
        formattedText = `### ${selectedText || 'Заголовок 3'}`;
        break;
      case 'list':
        formattedText = `* ${selectedText || 'пункт списка'}`;
        break;
      default:
        return;
    }
    
    const newText = beforeText + formattedText + afterText;
    updateSlideText(slideIndex, 'cardText', newText);
    
    setTimeout(() => {
      textarea.focus();
      textarea.setSelectionRange(beforeText.length + formattedText.length, beforeText.length + formattedText.length);
    }, 0);
  };

  // Добавление контента в слайд
  const addContentToSlide = (slideIndex, contentType, contentData) => {
    const newSlides = [...currentPath.slides];
    if (!newSlides[slideIndex].contents) {
      newSlides[slideIndex].contents = [];
    }
    
    newSlides[slideIndex].contents.push({
      id: Date.now() + Math.random(),
      type: contentType,
      data: contentData
    });
    
    setCurrentPath({
      ...currentPath,
      slides: newSlides
    });
    setShowContentSelector({ slideIndex: null, contentType: null });
  };

  // Удаление контента из слайда
  const removeContentFromSlide = (slideIndex, contentIndex) => {
    const newSlides = [...currentPath.slides];
    newSlides[slideIndex].contents = newSlides[slideIndex].contents.filter((_, i) => i !== contentIndex);
    
    setCurrentPath({
      ...currentPath,
      slides: newSlides
    });
  };

  // Перемещение контента вверх/вниз
  const moveContent = (slideIndex, contentIndex, direction) => {
    const newSlides = [...currentPath.slides];
    const contents = [...newSlides[slideIndex].contents];
    
    if (direction === 'up' && contentIndex > 0) {
      [contents[contentIndex - 1], contents[contentIndex]] = [contents[contentIndex], contents[contentIndex - 1]];
    } else if (direction === 'down' && contentIndex < contents.length - 1) {
      [contents[contentIndex], contents[contentIndex + 1]] = [contents[contentIndex + 1], contents[contentIndex]];
    }
    
    newSlides[slideIndex].contents = contents;
    setCurrentPath({
      ...currentPath,
      slides: newSlides
    });
  };

  // Функция для перемещения мини-пути вверх по порядку
  const movePathUp = async () => {
    if (!currentPath || currentPath.order === 0) return;
    
    const prevPath = miniPaths.find(p => p.order === currentPath.order - 1);
    if (!prevPath) return;
    
    await Promise.all([
      updateDoc(doc(db, 'miniPaths', currentPath.id), { order: currentPath.order - 1 }),
      updateDoc(doc(db, 'miniPaths', prevPath.id), { order: currentPath.order })
    ]);
    
    loadMiniPaths();
    setCurrentPath({
      ...currentPath,
      order: currentPath.order - 1
    });
  };

  // Функция для перемещения мини-пути вниз по порядку
  const movePathDown = async () => {
    if (!currentPath || currentPath.order === miniPaths.length - 1) return;
    
    const nextPath = miniPaths.find(p => p.order === currentPath.order + 1);
    if (!nextPath) return;
    
    await Promise.all([
      updateDoc(doc(db, 'miniPaths', currentPath.id), { order: currentPath.order + 1 }),
      updateDoc(doc(db, 'miniPaths', nextPath.id), { order: currentPath.order })
    ]);
    
    loadMiniPaths();
    setCurrentPath({
      ...currentPath,
      order: currentPath.order + 1
    });
  };

  const renderContentSelector = (slideIndex) => {
    const { contentType } = showContentSelector;
    if (!contentType) return null;

    return (
      <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
        <div className="bg-gray-900 rounded-xl max-w-4xl w-full max-h-[80vh] overflow-y-auto border border-gray-700">
          <div className="sticky top-0 bg-gray-900 p-6 border-b border-gray-700 flex justify-between items-center">
            <h3 className="text-xl font-semibold text-white">
              {contentType === CONTENT_TYPES.VIDEO && '📹 Добавить видео из Kinescope'}
              {contentType === CONTENT_TYPES.AUDIO && '🎵 Добавить аудио-урок'}
              {contentType === CONTENT_TYPES.TRAINING && '📚 Добавить тренинг'}
              {contentType === CONTENT_TYPES.BUTTON && '🔗 Добавить кнопку'}
              {contentType === CONTENT_TYPES.TEXT && '📝 Добавить текст'}
            </h3>
            <button
              onClick={() => setShowContentSelector({ slideIndex: null, contentType: null })}
              className="text-gray-400 hover:text-white text-2xl"
            >
              ✕
            </button>
          </div>

          <div className="p-6">
            {/* Видео из Kinescope */}
            {contentType === CONTENT_TYPES.VIDEO && (
              <div className="space-y-3">
                <input
                  type="text"
                  placeholder="Введите ID видео из Kinescope"
                  className="w-full p-3 bg-gray-800 border border-gray-700 rounded-lg text-white"
                  id="kinescopeInput"
                />
                <button
                  onClick={() => {
                    const input = document.getElementById('kinescopeInput');
                    if (input.value) {
                      addContentToSlide(slideIndex, CONTENT_TYPES.VIDEO, { kinescopeId: input.value });
                    }
                  }}
                  className="px-6 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
                >
                  Добавить
                </button>
              </div>
            )}

            {/* Аудио-уроки */}
            {contentType === CONTENT_TYPES.AUDIO && (
              <div className="grid gap-2 max-h-96 overflow-y-auto">
                {audioLessons.map(item => (
                  <button
                    key={item.id}
                    onClick={() => addContentToSlide(slideIndex, CONTENT_TYPES.AUDIO, { 
                      id: item.id,
                      title: item.title,
                      path: `/audioLessons/${item.id}`
                    })}
                    className="p-3 bg-gray-800 border border-gray-700 rounded-lg text-left hover:border-green-500 transition text-white"
                  >
                    <div className="font-medium">{item.title || 'Без названия'}</div>
                    <div className="text-sm text-gray-400">ID: {item.id}</div>
                  </button>
                ))}
                {audioLessons.length === 0 && (
                  <div className="text-gray-500 text-center p-4">Нет аудио-уроков</div>
                )}
              </div>
            )}

            {/* Тренинги */}
            {contentType === CONTENT_TYPES.TRAINING && (
              <div className="grid gap-2 max-h-96 overflow-y-auto">
                {trainings.map(item => (
                  <button
                    key={item.id}
                    onClick={() => addContentToSlide(slideIndex, CONTENT_TYPES.TRAINING, { 
                      id: item.id,
                      title: item.title,
                      path: `/trainings/${item.id}`
                    })}
                    className="p-3 bg-gray-800 border border-gray-700 rounded-lg text-left hover:border-blue-500 transition text-white"
                  >
                    <div className="font-medium">{item.title || 'Без названия'}</div>
                    <div className="text-sm text-gray-400">ID: {item.id}</div>
                  </button>
                ))}
                {trainings.length === 0 && (
                  <div className="text-gray-500 text-center p-4">Нет тренингов</div>
                )}
              </div>
            )}

            {/* Кнопка со ссылкой */}
            {contentType === CONTENT_TYPES.BUTTON && (
              <div className="space-y-3">
                <input
                  type="text"
                  placeholder="Текст кнопки"
                  className="w-full p-3 bg-gray-800 border border-gray-700 rounded-lg text-white"
                  id="buttonText"
                  defaultValue="Перейти"
                />
                <input
                  type="url"
                  placeholder="URL ссылки"
                  className="w-full p-3 bg-gray-800 border border-gray-700 rounded-lg text-white"
                  id="buttonUrl"
                />
                <button
                  onClick={() => {
                    const text = document.getElementById('buttonText').value;
                    const url = document.getElementById('buttonUrl').value;
                    if (url) {
                      addContentToSlide(slideIndex, CONTENT_TYPES.BUTTON, { url, text });
                    }
                  }}
                  className="px-6 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700"
                >
                  Добавить кнопку
                </button>
              </div>
            )}

            {/* Простой текст */}
            {contentType === CONTENT_TYPES.TEXT && (
              <div className="space-y-3">
                <textarea
                  placeholder="Введите текст"
                  className="w-full p-3 bg-gray-800 border border-gray-700 rounded-lg text-white"
                  rows="6"
                  id="simpleText"
                />
                <button
                  onClick={() => {
                    const text = document.getElementById('simpleText').value;
                    if (text) {
                      addContentToSlide(slideIndex, CONTENT_TYPES.TEXT, { text });
                    }
                  }}
                  className="px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700"
                >
                  Добавить текст
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const renderContentItem = (content, slideIndex, contentIndex) => {
    return (
      <div key={content.id || contentIndex} className="bg-gray-800 rounded-lg p-3 border border-gray-700">
        <div className="flex justify-between items-start">
          <div className="flex items-center gap-2">
            <span className="text-sm px-2 py-1 rounded bg-gray-700 text-gray-300">
              {content.type === CONTENT_TYPES.VIDEO && '📹 Видео'}
              {content.type === CONTENT_TYPES.AUDIO && '🎵 Аудио'}
              {content.type === CONTENT_TYPES.TRAINING && '📚 Тренинг'}
              {content.type === CONTENT_TYPES.BUTTON && '🔗 Кнопка'}
              {content.type === CONTENT_TYPES.TEXT && '📝 Текст'}
            </span>
            
            <div className="flex gap-1 ml-2">
              <button
                onClick={() => moveContent(slideIndex, contentIndex, 'up')}
                disabled={contentIndex === 0}
                className="p-1 bg-gray-700 hover:bg-gray-600 rounded text-white disabled:opacity-30 text-xs"
                title="Переместить вверх"
              >
                ↑
              </button>
              <button
                onClick={() => moveContent(slideIndex, contentIndex, 'down')}
                disabled={contentIndex === currentPath.slides[slideIndex].contents.length - 1}
                className="p-1 bg-gray-700 hover:bg-gray-600 rounded text-white disabled:opacity-30 text-xs"
                title="Переместить вниз"
              >
                ↓
              </button>
            </div>
          </div>
          
          <button
            onClick={() => removeContentFromSlide(slideIndex, contentIndex)}
            className="text-red-400 hover:text-red-300 text-sm"
          >
            ✕
          </button>
        </div>
        
        <div className="mt-2 text-sm text-gray-300">
          {content.type === CONTENT_TYPES.VIDEO && (
            <div>Kinescope ID: {content.data.kinescopeId}</div>
          )}
          {content.type === CONTENT_TYPES.AUDIO && (
            <div>
              <div>{content.data.title || 'Аудио-урок'}</div>
              <div className="text-gray-500 text-xs">ID: {content.data.id}</div>
            </div>
          )}
          {content.type === CONTENT_TYPES.TRAINING && (
            <div>
              <div>{content.data.title || 'Тренинг'}</div>
              <div className="text-gray-500 text-xs">ID: {content.data.id}</div>
            </div>
          )}
          {content.type === CONTENT_TYPES.BUTTON && (
            <div>
              <div>Текст: {content.data.text}</div>
              <div className="text-gray-500 text-xs truncate">URL: {content.data.url}</div>
            </div>
          )}
          {content.type === CONTENT_TYPES.TEXT && (
            <div className="whitespace-pre-wrap max-h-20 overflow-y-auto">{content.data.text}</div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-950 text-gray-100 p-6">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-bold mb-6 text-white">Управление мини-путями</h1>

        {/* Список мини-путей с порядком */}
        <div className="bg-gray-900 rounded-lg shadow p-4 mb-6 border border-gray-800">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-semibold text-white">Мини-пути (порядок отображения)</h2>
            <button
              onClick={createNewPath}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
            >
              + Создать новый
            </button>
          </div>

          <div className="space-y-2">
            {miniPaths.map((path, index) => (
              <div
                key={path.id}
                className={`flex items-center gap-3 p-3 border rounded transition ${
                  selectedPathId === path.id 
                    ? 'border-blue-500 bg-blue-900/30' 
                    : 'border-gray-800 bg-gray-800/50 hover:bg-gray-800'
                }`}
              >
                <div className="w-8 h-8 rounded-full bg-gray-700 flex items-center justify-center text-sm font-medium">
                  {index + 1}
                </div>

                <button
                  onClick={() => {
                    setSelectedPathId(path.id);
                    setCurrentPath(path);
                  }}
                  className="flex-1 text-left"
                >
                  <div className="font-medium text-white">{path.title}</div>
                  <div className="text-sm text-gray-400">
                    Слайдов: {path.slides?.length || 0}
                  </div>
                </button>

                <div className="flex gap-1">
                  <button
                    onClick={() => {
                      setCurrentPath(path);
                      movePathUp();
                    }}
                    disabled={index === 0}
                    className="p-2 bg-gray-800 hover:bg-gray-700 rounded text-white disabled:opacity-30"
                    title="Переместить вверх"
                  >
                    ↑
                  </button>
                  <button
                    onClick={() => {
                      setCurrentPath(path);
                      movePathDown();
                    }}
                    disabled={index === miniPaths.length - 1}
                    className="p-2 bg-gray-800 hover:bg-gray-700 rounded text-white disabled:opacity-30"
                    title="Переместить вниз"
                  >
                    ↓
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Редактор выбранного мини-пути */}
        {currentPath && (
          <div className="bg-gray-900 rounded-lg shadow p-6 border border-gray-800">
            <div className="flex justify-between items-center mb-6">
              <div className="flex-1 space-y-4">
                <input
                  type="text"
                  value={currentPath.title}
                  onChange={(e) => setCurrentPath({
                    ...currentPath,
                    title: e.target.value
                  })}
                  className="text-2xl font-bold bg-transparent border-b border-gray-700 focus:border-blue-500 outline-none text-white w-full"
                  placeholder="Название мини-пути"
                />

                {/* Блок загрузки изображения */}
                <div className="mt-4">
                  <label className="block text-sm font-medium text-gray-400 mb-2">
                    Изображение мини-пути
                  </label>
                  <div className="flex items-center gap-4">
                    {currentPath.image && (
                      <div className="w-20 h-20 rounded-lg overflow-hidden border border-gray-700">
                        <img 
                          src={currentPath.image} 
                          alt="Preview" 
                          className="w-full h-full object-cover"
                        />
                      </div>
                    )}
                    <div className="flex-1">
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleImageUpload}
                        className="hidden"
                        id="image-upload"
                        disabled={uploading}
                      />
                      <label
                        htmlFor="image-upload"
                        className={`inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg cursor-pointer hover:bg-blue-700 transition ${
                          uploading ? 'opacity-50 pointer-events-none' : ''
                        }`}
                      >
                        {uploading ? 'Загрузка...' : 'Загрузить изображение'}
                      </label>
                      {currentPath.image && (
                        <button
                          onClick={() => setCurrentPath({ ...currentPath, image: '' })}
                          className="ml-2 px-4 py-2 bg-red-600/20 text-red-400 rounded-lg hover:bg-red-600/40 transition"
                        >
                          Удалить
                        </button>
                      )}
                    </div>
                  </div>
                  <p className="text-xs text-gray-500 mt-1">
                    Формат: JPG, PNG, WEBP. Макс. размер: 10MB
                  </p>
                </div>
              </div>

              <div className="flex gap-2">
                <button
                  onClick={deletePath}
                  className="px-6 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition"
                >
                  Удалить
                </button>
                <button
                  onClick={savePath}
                  className="px-6 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition"
                >
                  Сохранить
                </button>
              </div>
            </div>

            <div className="space-y-6">
              {currentPath.slides.map((slide, slideIndex) => (
                <div key={slideIndex} className="border border-gray-800 rounded-lg p-4 bg-gray-800/50">
                  <div className="flex justify-between items-center mb-3">
                    <h3 className="text-lg font-semibold text-white">Слайд {slide.number}</h3>
                    <button
                      onClick={() => removeSlide(slideIndex)}
                      className="text-red-400 hover:text-red-300 text-sm transition disabled:opacity-50"
                      disabled={currentPath.slides.length <= 1}
                    >
                      Удалить слайд
                    </button>
                  </div>

                  <div className="space-y-4">
                    {/* Текст слайда */}
                    <div>
                      <label className="block text-sm font-medium text-gray-400 mb-1">
                        Текст слайда (18px italic)
                      </label>
                      <input
                        type="text"
                        value={slide.text}
                        onChange={(e) => updateSlideText(slideIndex, 'text', e.target.value)}
                        className="w-full p-2 bg-gray-800 border border-gray-700 rounded focus:ring-2 focus:ring-blue-500 text-white"
                        placeholder="Введите текст слайда"
                      />
                    </div>

                    {/* Текст карточки с панелью форматирования */}
                    <div>
                      <label className="block text-sm font-medium text-gray-400 mb-1">
                        Текст карточки
                      </label>
                      
                      <div className="flex flex-wrap gap-1 mb-2 p-2 bg-gray-800 rounded-lg border border-gray-700">
                        <button
                          onClick={() => insertFormatting(slideIndex, 'bold')}
                          className="px-3 py-1 bg-gray-700 hover:bg-gray-600 rounded text-white font-bold"
                          title="Жирный"
                        >
                          B
                        </button>
                        <button
                          onClick={() => insertFormatting(slideIndex, 'italic')}
                          className="px-3 py-1 bg-gray-700 hover:bg-gray-600 rounded text-white italic"
                          title="Курсив"
                        >
                          I
                        </button>
                        <button
                          onClick={() => insertFormatting(slideIndex, 'code')}
                          className="px-3 py-1 bg-gray-700 hover:bg-gray-600 rounded text-white font-mono"
                          title="Код"
                        >
                          &lt;/&gt;
                        </button>
                        <span className="w-px h-6 bg-gray-700 mx-1"></span>
                        <button
                          onClick={() => insertFormatting(slideIndex, 'h1')}
                          className="px-3 py-1 bg-gray-700 hover:bg-gray-600 rounded text-white text-sm"
                          title="Заголовок 1"
                        >
                          H1
                        </button>
                        <button
                          onClick={() => insertFormatting(slideIndex, 'h2')}
                          className="px-3 py-1 bg-gray-700 hover:bg-gray-600 rounded text-white text-sm"
                          title="Заголовок 2"
                        >
                          H2
                        </button>
                        <button
                          onClick={() => insertFormatting(slideIndex, 'h3')}
                          className="px-3 py-1 bg-gray-700 hover:bg-gray-600 rounded text-white text-sm"
                          title="Заголовок 3"
                        >
                          H3
                        </button>
                        <span className="w-px h-6 bg-gray-700 mx-1"></span>
                        <button
                          onClick={() => insertFormatting(slideIndex, 'list')}
                          className="px-3 py-1 bg-gray-700 hover:bg-gray-600 rounded text-white"
                          title="Список"
                        >
                          •
                        </button>
                      </div>

                      <textarea
                        id={`cardText-${slideIndex}`}
                        value={slide.cardText}
                        onChange={(e) => updateSlideText(slideIndex, 'cardText', e.target.value)}
                        className="w-full p-2 bg-gray-800 border border-gray-700 rounded focus:ring-2 focus:ring-blue-500 text-white font-mono text-sm"
                        rows="4"
                        placeholder="Введите текст..."
                      />
                    </div>

                    {/* Множественный контент */}
                    <div>
                      <div className="flex justify-between items-center mb-2">
                        <label className="text-sm font-medium text-gray-400">
                          Контент слайда ({slide.contents?.length || 0})
                        </label>
                        <div className="flex gap-2">
                          <button
                            onClick={() => setShowContentSelector({ slideIndex, contentType: CONTENT_TYPES.VIDEO })}
                            className="px-2 py-1 bg-purple-600/20 hover:bg-purple-600/40 text-purple-400 rounded text-xs"
                          >
                            + Видео
                          </button>
                          <button
                            onClick={() => setShowContentSelector({ slideIndex, contentType: CONTENT_TYPES.AUDIO })}
                            className="px-2 py-1 bg-green-600/20 hover:bg-green-600/40 text-green-400 rounded text-xs"
                          >
                            + Аудио
                          </button>
                          <button
                            onClick={() => setShowContentSelector({ slideIndex, contentType: CONTENT_TYPES.TRAINING })}
                            className="px-2 py-1 bg-blue-600/20 hover:bg-blue-600/40 text-blue-400 rounded text-xs"
                          >
                            + Тренинг
                          </button>
                          <button
                            onClick={() => setShowContentSelector({ slideIndex, contentType: CONTENT_TYPES.BUTTON })}
                            className="px-2 py-1 bg-red-600/20 hover:bg-red-600/40 text-red-400 rounded text-xs"
                          >
                            + Кнопка
                          </button>
                          <button
                            onClick={() => setShowContentSelector({ slideIndex, contentType: CONTENT_TYPES.TEXT })}
                            className="px-2 py-1 bg-gray-600/20 hover:bg-gray-600/40 text-gray-400 rounded text-xs"
                          >
                            + Текст
                          </button>
                        </div>
                      </div>

                      {slide.contents && slide.contents.length > 0 ? (
                        <div className="space-y-2">
                          {slide.contents.map((content, contentIndex) => 
                            renderContentItem(content, slideIndex, contentIndex)
                          )}
                        </div>
                      ) : (
                        <div className="text-center py-4 text-gray-500 text-sm border border-dashed border-gray-700 rounded-lg">
                          Нет контента. Нажмите на кнопки выше, чтобы добавить.
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}

              {/* Кнопка добавления слайда */}
              {currentPath.slides.length < 10 && (
                <button
                  onClick={addSlide}
                  className="w-full p-4 border-2 border-dashed border-gray-700 rounded-lg text-gray-400 hover:border-blue-500 hover:text-blue-400 transition"
                >
                  + Добавить слайд (макс. 10)
                </button>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Модальное окно выбора контента */}
      {showContentSelector.slideIndex !== null && renderContentSelector(showContentSelector.slideIndex)}
    </div>
  );
}